'use client';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { FC, SyntheticEvent, useState } from 'react';
import { ParseBBCode } from 'atoms/ParseBBCode';
import { useMediaQuery } from 'modules/mui/hooks';
import { ProductDetailsTile } from './ProductDetailsTile';
import { IProductDetailsTabs, IProductTabPanel } from './types';
import styles from './styles.module.css';

const ProductTabPanel: FC<IProductTabPanel> = ({ product, isHidden }) => {
  return (
    <div role="tabpanel" hidden={isHidden} aria-labelledby={product.name}>
      <ProductDetailsTile product={product} />
    </div>
  );
};

export const ProductDetailsTabs: FC<IProductDetailsTabs> = ({ products }) => {
  const [activeTab, setActiveTab] = useState(0);
  const { isMobile } = useMediaQuery();

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="product tabs"
        centered={!isMobile}
        allowScrollButtonsMobile
        scrollButtons={false}
        visibleScrollbar
        variant={isMobile ? 'scrollable' : 'fullWidth'}
        classes={{
          root: styles.tabs,
          flexContainer: styles.tabsContainer,
          indicator: styles.tabIndicator,
        }}
      >
        {products.map(({ name, productName }) => (
          <Tab
            key={name}
            label={<ParseBBCode content={productName} />}
            classes={{
              root: styles.tabButton,
              selected: styles.tabButtonSelected,
            }}
          />
        ))}
      </Tabs>
      {products.map((product, index) => (
        <ProductTabPanel
          key={product.id}
          product={product}
          isHidden={activeTab !== index}
        />
      ))}
    </>
  );
};
